// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-box[data-v-5153d9e0] {\n  padding: 0.53333rem;\n  font-size: 0.37333rem;\n  line-height: 1.5;\n  text-align: justify;\n}\n.page-box h2[data-v-5153d9e0] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
